import { JOB_TYPES } from "@/lib/constants";
import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import { Icon } from "components";

export const TypeCell = ({ getValue }) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <Icon
          icon={JOB_TYPES[getValue()].icon}
          className="text-muted-foreground size-4"
        />
      </TooltipTrigger>
      <TooltipContent>{JOB_TYPES[getValue()].label}</TooltipContent>
    </Tooltip>
  );
};

export default TypeCell;
